/*!
 *
 *  get-filesize.js
 *
 */


var fileSizeGetter = {
	conf : {
		extension : [ '.png', '.gif', '.jpg', '.jpeg', '.pdf', '.xlsx', '.xls', '.docx', '.doc', '.pptx', '.ppt', '.zip', '.lzh', '.cab', '.txt', '.exe' ]
	},
	getFileSize : function( href ) {
		// HTTP通信用オブジェクト生成
		var httpObj = fileSizeGetter.createXMLHttpRequest();
		if ( !httpObj ) {
			return false;
		}
		// 同期通信
		httpObj.open('HEAD', href, false);
		try {
			httpObj.send(null);
		} catch(e) {
			// 404 Not Found
			return false;
		}
		if ( !httpObj.getResponseHeader('Content-Length') ) {
			// No Content-Length
			return false;
		} else {
			// Return Content-Length
			if ( httpObj.readyState == 4 && httpObj.status == 200 ) {
				return httpObj.getResponseHeader('Content-Length');
			} else {
				return false;
			}
		}
	},
	convUnit : function( num ) {
		if ( num > 1073741824 ) {
			// GByte
			num = num / (1024*1024*1024);
			num = num * 10;
			return Math.round(num)/10 + 'GB';
		} else if ( num > 1048576 ) {
			// MByte
			num = num / (1024*1024);
			num = num * 10;
			return Math.round(num)/10 + 'MB';
		} else if ( num > 1024 ) {
			// KByte
			num = num / 1024;
			num = num * 10;
			return Math.round(num)/10 + 'KB';
		} else {
			// byte
			num = num * 10;
			return Math.round(num)/10 + 'B';
		}
	},
	createXMLHttpRequest : function() {
		var XMLhttpObject = null;
		try {
			XMLhttpObject = new XMLHttpRequest();
		} catch(e) {
			var progids = new Array('MSXML2.XMLHTTP.5.0', 'MSXML2.XMLHTTP.4.0', 'MSXML2.XMLHTTP.3.0', 'MSXML2.XMLHTTP', 'Microsoft.XMLHTTP');
			for (var i = 0, len = progids.length; i < len; i++) {
				try {
					XMLhttpObject = new ActiveXObject(progids[i]);
				} catch (e) {
					XMLhttpObject = null;
				}
			}
		}
		return XMLhttpObject;
	}
};

$.fn.getFileSize = function(options){
	var opt = options ? options : {};

	return this.each(function(){
		var _href = $(this).attr('href'),
			_size = fileSizeGetter.getFileSize(_href),
			_text = $(this).text();
		_text += '（' + fileSizeGetter.convUnit(_size) + '）';
		$(this).text(_text);
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/get-filesize.js
// module id = 23
// module chunks = 0